<template>
  <div class="ad-card">
    <img :src="imageSrc" alt="Tamba Group" class="ad-image" />
    <div class="ad-content">
      <p class="ad-text">{{ adText }}</p>
      <a :href="adLink" class="ad-link" target="_blank">Learn More</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imageSrc: {
      type: String,
      required: true
    },
    adText: {
      type: String,
      required: true
    },
    adLink: {
      type: String,
      required: true
    }
  }
}
</script>
<style scoped>
.ad-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 10px; /* Reduced padding */
  max-width: 220px; /* Reduced width */
  text-align: center;
}

.ad-image {
  width: 100%;
  border-radius: 6px; /* Slightly smaller radius */
  height: 120px; /* Set a fixed height */
  object-fit: cover; /* Ensure image maintains aspect ratio */
}

.ad-content {
  margin-top: 5px; /* Reduced margin */
}

.ad-text {
  font-size: 12px; /* Smaller font */
  color: #333;
  margin-bottom: 5px;
}

.ad-link {
  font-size: 12px; /* Adjusted font */
  color: #ff5a5f;
  text-decoration: none;
  font-weight: bold;
}

.ad-link:hover {
  text-decoration: underline;
}

/* Hide on Mobile */
@media (max-width: 768px) {
  .ad-card {
    display: none;
  }
}
</style>
